var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "align-stretch justify-start" },
        [
          _c(
            "v-col",
            { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
            [
              _c("TeamWidget", {
                attrs: { teamId: _vm.currentUser.team.teamId },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA") &&
          _vm.currentUser.team &&
          _vm.currentUser.team.teamId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
                [
                  _c("LastGameWidget", {
                    staticClass: "flex-grow-1",
                    attrs: { teamId: _vm.currentUser.team.teamId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
            [
              _c("NextGameWidget", {
                attrs: { teamId: _vm.currentUser.team.teamId },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("LastScoutingAnalysesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("ScoutingTasksWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("UploadedGamesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("CapturePlaylistsWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_REPORTS")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("ReportsWidget", {
                    on: {
                      heightChange: function ($event) {
                        _vm.reportsHeight = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("LastPlayersSearch", {
                style: {
                  height:
                    _vm.reportsHeight || _vm.charts2Height
                      ? (_vm.reportsHeight || _vm.charts2Height) + "px"
                      : undefined,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("ChartsWidget", {
                    staticClass: "elevation-2",
                    attrs: { slides: ["pointsVsXPointsChart"] },
                    on: {
                      heightChange: function ($event) {
                        _vm.charts2Height = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("FavoritesWidget", {
                style: { height: _vm.charts2Height + "px" },
                attrs: { userId: _vm.currentUser.id },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("ChartsWidget", {
                    staticClass: "elevation-2",
                    attrs: { slides: ["playerScoutChart"] },
                    on: {
                      heightChange: function ($event) {
                        _vm.charts3Height = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("CollectionsWidget", {
                style: { height: _vm.charts3Height + "px" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }